"use strict";

(self.webpackChunkuklash = self.webpackChunkuklash || []).push([ [ 617 ], {
  617: function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    __webpack_require__.r(__webpack_exports__), __webpack_exports__.default = void (customElements.get("localization-form") || customElements.define("localization-form", class extends HTMLElement {
      form=this.querySelector("form");
      handleSubmit(event) {
        event.stopImmediatePropagation(), event.stopPropagation(), event.preventDefault();
        let shopDomain = orbito && orbito.getCountryDomain() || location.host, countryCode = this.form.querySelector('[name="country_code"]').value.trim().toLowerCase(), returnToInput = this.form.querySelector('input[name="return_to"]'), urlCountryRedirect = returnToInput.value.includes("?") ? "&mdApp_countryCodeDomain=" + countryCode : "?mdApp_countryCodeDomain=" + countryCode;
        returnToInput.value = returnToInput.value + urlCountryRedirect, document.cookie = `mdApp_countryCodeDomain=${countryCode}; domain=${shopDomain}; path=/; max-age=5184000;`, 
        countryCode && this.data[countryCode] && location.host !== this.data[countryCode].trim() ? location.replace("https://" + this.data[countryCode].trim() + returnToInput.value.replace(/\/[a-z]{2}-[a-z]{2}\/?/i, "/")) : this.form.submit();
      }
      constructor() {
        super();
      }
      connectedCallback() {
        this.querySelector('[type="application/json"]') && (this.data = JSON.parse(this.querySelector('[type="application/json"]').textContent.toLowerCase()), 
        this.form.addEventListener("change", (event => this.handleSubmit(event))), this.form.addEventListener("submit", (event => this.handleSubmit(event))));
      }
    }));
  }
} ]);